module.exports = __webpack_public_path__ + "img/contact.760a1908.svg";